// admin.tsx — T094 (1/5)
// Route parente /admin — réutilise le layout applicatif principal (AppLayout :
// même sidebar/navbar/breadcrumb que le reste de l'application), guard basé
// sur les permissions admin.

import { createFileRoute, Outlet } from "@tanstack/react-router";

import { useAuth } from "@/application/contexts/AuthContext";
import { AppLayout } from "@/presentation/layouts/AppLayout";
import { UnauthorizedPage } from "@/presentation/pages/UnauthorizedPage";

export const Route = createFileRoute("/admin")({
  component: function AdminRouteComponent() {
    const { canAccessAdmin, isLoading } = useAuth();

    if (isLoading) {
      return null;
    }

    if (!canAccessAdmin) {
      return <UnauthorizedPage />;
    }

    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  },
});
